var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loaded)?_c('data-list',{attrs:{"folder-config":_vm.folderConfig,"title":"Отзывы","breadcrumbs":_vm.breadcrumbs,"data-source":_vm.dataSource,"customCreateItemFields":_vm.customCreateItemFields,"customCreateItemModel":_vm.customCreateItemModel,"create-item-actions":_vm.actions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }